import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { of, Subscription } from 'rxjs';
import { catchError, switchMap, tap } from 'rxjs/operators';
import { NotificationService } from 'src/app/modules/general/services/notification.service';
import { ScanCard } from '../../../vu/models/scan-card';
import { TouchTileService } from '../../../vu/services/touch-tile.service';
import { VuCommunicationService } from '../../../vu/services/vu-communication.service';
import { ScanPartnerCodeInfo } from '../../models/scan-partner-code-info';
import { PartnerCodeStateService } from '../../services/partner-code-state.service';

@Component({
  selector: 'app-partner-code-scan',
  templateUrl: './partner-code-scan.component.html',
  styleUrls: ['./partner-code-scan.component.css']
})
export class PartnerCodeScanComponent implements OnInit, OnDestroy {

  @Output()
  scanPartnerCode: EventEmitter<ScanPartnerCodeInfo> = new EventEmitter<ScanPartnerCodeInfo>();

  @Output()
  eventBack = new EventEmitter();

  private _scanCardSubscription: Subscription;

  constructor(
    private _vuCommunicationService: VuCommunicationService,
    private _partnerCodeStateService: PartnerCodeStateService,
    private touchTileService: TouchTileService,
    private notificationService: NotificationService,
  ) { }

  ngOnInit(): void {
    this.subscribeScanPartnerCode();
  }

  ngOnDestroy(): void {
    if (this._scanCardSubscription) {
      this._scanCardSubscription.unsubscribe();
      this._scanCardSubscription = null;
    }
    this.touchTileService.rfidCardLedEnable(false);
    this.notificationService.hide(PartnerCodeScanComponent.name);
  }

  protected subscribeScanPartnerCode(): void {
    this.touchTileService.rfidCardLedEnable(true);
    this._scanCardSubscription = this._vuCommunicationService.scanCardCodeEvent.pipe(
      switchMap(
        (card: ScanCard) => {
          if (!card) {
            return of(null);
          }

          this.notificationService.hide(PartnerCodeScanComponent.name);

          return this._partnerCodeStateService.getPartnerInfo(card)
            .pipe(
              tap((scanPartnerCodeInfo: ScanPartnerCodeInfo) => {
                this.scanPartnerCode.emit(scanPartnerCodeInfo);
              }),
              catchError(error => {
                this.notificationService.show(PartnerCodeScanComponent.name, error?.message);
                return of(null);
              })
            );
        })
    ).subscribe();
  }

  onBack(): void {
    this.eventBack.emit();
  }
}
